export { default } from './ReferralMedicationTable';
